import React from 'react';
import './CartPickerTriggerIcon.less';

export const CartPickerTriggerIcon = ({icon}) => {
	return <span className="cart-picker-trigger-icon" dangerouslySetInnerHTML={{__html: icon}}></span>;
};
